import React from 'react';

function FileOperationsContent() {
  return (
    <>
      <p>RepoPrompt provides several ways to interact with files beyond just selecting them for prompts.</p>
      
      <h3>Previewing File Content</h3>
      <p>To quickly examine a file's content without selecting it:</p>
      <ol>
        <li>In the "Selected Files" panel on the right, hover over a file card</li>
        <li>Click the magnifying glass icon that appears</li>
        <li>A modal window will pop up showing the content of that file</li>
        <li>Close the preview by clicking outside the modal or using its close button</li>
      </ol>
      
      <h3>File Context Menu</h3>
      <p>Right-clicking on any file or folder in the main file tree provides access to additional operations:</p>
      <ul>
        <li><strong>Copy:</strong> Copies the file's content to your clipboard</li>
        <li><strong>Reveal in Finder/Explorer:</strong> Opens the file's location in your system's file explorer</li>
        <li><strong>Copy Relative Path:</strong> Copies the file's path relative to the workspace root</li>
        <li><strong>Copy Full Path:</strong> Copies the file's absolute path on your system</li>
        <li><strong>Select All Children:</strong> (For folders) Selects all files within the folder</li>
        <li><strong>Deselect All Children:</strong> (For folders) Deselects all files within the folder</li>
      </ul>
      
      <h3>Working with Multiple Files</h3>
      <p>The file context menu also enables batch operations:</p>
      <ul>
        <li>Right-click on a folder and use "Select All Children" to quickly include all files</li>
        <li>Use "Deselect All Children" to remove all files in a folder from your selection</li>
        <li>Hold Shift while checking boxes to select consecutive files</li>
      </ul>
      
      <div className="tip-box">
        <strong>Tip:</strong> The "Copy Relative Path" option is particularly useful when you want to explicitly reference a file in your prompt instructions.
      </div>
    </>
  );
}

export default FileOperationsContent;